import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';

import './index.scss';
import { getChartsShowCount } from '../../utils';

const percentageForm = (percentage: number) => {
  const value = Math.abs(percentage);
  if (value > 9999) {
    return '9999+';
  } else {
    return value.toFixed(2);
  }
};

export default function NumTrends({
  percentage,
  value,
  className,
  showValue = true,
  decimal,
  emptyValue,
  hideTrend = false,
  format,
}: {
  percentage: number;
  value: number;
  className?: string;
  showValue?: boolean;
  decimal?: number;
  emptyValue?: string;
  hideTrend?: boolean;
  format?: (val: number) => number | string;
}) {
  let status = 'none';
  if (percentage > 0 || percentage < 0) {
    status = percentage > 0 ? 'up' : 'down';
  }

  const textStyleMap: any = {
    none: '',
    up: 'trends-num--green',
    down: 'trends-num--red',
  };

  const iconMap: any = {
    up: 'green-up-new',
    down: 'red-down-new',
  };

  return (
    <div className={`dbo-numtrends ${className}`}>
      {showValue && (
        <span className="dbo-numtrends-num">
          {format?.(value) || getChartsShowCount(value, decimal, emptyValue)}
        </span>
      )}
      <div className="dbo-numtrends-trends">
        {status !== 'none' ? (
          <>
            <span
              className={`trends-num ${textStyleMap[status]}`}
            >{`${percentageForm(percentage)}%`}</span>
            <SvgIcon type={iconMap[status]} className="trends-icon" />
          </>
        ) : (
          !hideTrend && <span className="trends-num">-</span>
        )}
      </div>
    </div>
  );
}
